export type Language = 'en' | 'es'

export const t = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      pricing: 'Pricing',
      gallery: 'Gallery',
      faq: 'FAQ',
      rescueMe: 'GET A QUOTE',
    },
    hero: {
      headline: 'MOVING CRITICAL? CALL THE FIGHTERS.',
      sub: "We don't just move boxes; we execute residential rescues. Fixed-rate or hourly options. Florida's most trusted moving squad.",
      cta: 'GET MY QUOTE',
    },
    trustBar: {
      moves: 'Successful Rescues',
      rating: 'Google Rating',
      pricing: 'Flexible Pricing',
      licensed: 'Licensed & Insured',
    },
    howItWorks: {
      title: 'HOW IT WORKS',
      step1: {
        title: 'Request Your Rescue',
        desc: 'Fill out the form. A specialist calls you back to discuss details and pricing.',
      },
      step2: {
        title: 'We Deploy',
        desc: 'Our uniformed squad arrives on time with all equipment ready.',
      },
      step3: {
        title: 'Mission Complete',
        desc: 'Everything in its place. Transparent invoice. Job done.',
      },
    },
    booking: {
      title: 'REQUEST A RESCUE',
      subtitle:
        'Fill out the form below and a Move Fighters specialist will call you back to discuss the details of your move and your custom quote.',
      sizeLabel: 'Move Size',
      sizeOptions: [
        { value: 'studio', label: 'Studio / 1 Bedroom' },
        { value: '2bedroom', label: '2 Bedrooms' },
        { value: '3bedroom', label: '3 Bedrooms' },
        { value: '4bedroom', label: '4+ Bedrooms / Large Home' },
        { value: 'office', label: 'Office / Commercial' },
      ],
      serviceTypeLabel: 'Pricing Preference',
      serviceTypeOptions: [
        { value: 'flat', label: 'Flat-Rate Quote' },
        { value: 'hourly', label: 'Hourly Rate' },
        { value: 'either', label: 'Show Me Both' },
      ],
      originLabel: 'Pickup Address',
      destLabel: 'Delivery Address',
      dateLabel: 'Preferred Moving Date',
      dateHint: 'We recommend 72h advance notice',
      nameLabel: 'Full Name',
      emailLabel: 'Email Address',
      phoneLabel: 'Phone Number',
      notesLabel: 'Additional Notes (optional)',
      notesPlaceholder: 'Stairs, large items, parking restrictions, etc.',
      submit: 'REQUEST MY QUOTE',
      submitting: 'SENDING...',
      footer: 'No payment required. A specialist will contact you shortly.',
      success: {
        title: 'REQUEST RECEIVED',
        message:
          'Thank you for choosing Move Fighters. One of our specialists will call you shortly from',
        phone: '(813) 476-8935',
        message2:
          "with your custom quote and final pricing. Please answer — the call will come from this exact number so you don't miss your rescue.",
        cta: 'BACK TO HOMEPAGE',
      },
      error:
        'Something went wrong. Please try again or call us at (813) 476-8935.',
    },
    pricing: {
      title: 'OUR MOVING PACKAGES',
      subtitle:
        'Choose the package that fits your move. Final pricing is provided after a quick call with our specialist.',
      popular: 'MOST POPULAR',
      cta: 'GET A QUOTE',
      cards: [
        {
          title: 'Studio / 1 Bedroom',
          features: [
            '2 Fighters',
            'Moving Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Stairs at No Extra Charge',
            'Residential Insurance',
          ],
        },
        {
          title: '2 Bedroom Home',
          features: [
            '3 Fighters',
            'Moving Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Stairs at No Extra Charge',
            'Residential Insurance',
          ],
        },
        {
          title: '3 Bedroom Home',
          features: [
            '3 Fighters',
            'Larger Truck',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Priority Scheduling',
            'Residential Insurance',
          ],
        },
        {
          title: '4+ Bedroom / Custom',
          features: [
            '4+ Fighters',
            'Multiple Trucks',
            'Travel Fee Included',
            'Disassembly & Reassembly Included',
            'Dedicated Coordinator',
            'Specialty & White Glove Handling',
          ],
        },
      ],
      note: '* Packing materials (boxes, tape, paper, wrap) billed separately based on usage.',
    },
    quoteModal: {
      title: 'TELL US ABOUT YOUR MOVE',
      subtitle:
        'The more details you share, the more accurate your quote will be. Our specialist will call you back with the final price.',
      selectedPackage: 'Selected package',
      sectionContact: 'Your contact info',
      sectionAddresses: 'Addresses',
      sectionDate: 'When are you moving?',
      sectionInventory: 'Inventory & details',
      sectionPhotos: 'Photos (optional but recommended)',
      nameLabel: 'Full Name',
      phoneLabel: 'Phone Number',
      emailLabel: 'Email Address',
      originLabel: 'Pickup Address',
      originPlaceholder: '123 Main St, City, FL — include floor / apt #',
      destLabel: 'Delivery Address',
      destPlaceholder: '456 New St, City, FL — include floor / apt #',
      stairsLabel: 'Stairs / Elevator',
      stairsOptions: [
        { value: 'ground', label: 'Ground floor only' },
        { value: 'stairs', label: 'Stairs' },
        { value: 'elevator', label: 'Elevator' },
        { value: 'both', label: 'Both locations have stairs/elevator' },
      ],
      dateLabel: 'Preferred Move Date',
      dateFlexLabel: 'Flexibility',
      dateFlexOptions: [
        { value: 'exact', label: 'Exact date' },
        { value: 'flexible-3', label: 'Flexible (±3 days)' },
        { value: 'flexible-week', label: 'Flexible (within a week)' },
        { value: 'asap', label: 'As soon as possible' },
      ],
      inventoryLabel: 'Describe your inventory',
      inventoryPlaceholder:
        'List rooms and main items (e.g. king bed, sectional sofa, washer/dryer, 55" TV, dining table for 6, large mirrors, gym equipment...)',
      specialItemsLabel: 'Special items (check all that apply)',
      specialItems: [
        'Piano',
        'Pool Table',
        'Safe',
        'Gun Safe',
        'Artwork / Antiques',
        'Aquarium',
        'Treadmill / Gym',
        'Large TV (65"+)',
        'Hot Tub',
        'Appliances',
      ],
      packingLabel: 'Do you need packing service?',
      packingOptions: [
        { value: 'no', label: 'No, I will pack everything myself' },
        { value: 'partial', label: 'Partial — I need help with fragile items' },
        { value: 'full', label: 'Full packing service' },
      ],
      notesLabel: 'Special needs or anything else we should know',
      notesPlaceholder:
        'Long carry, narrow doorways, parking restrictions, time windows, pets, etc.',
      photosLabel: 'Upload photos and videos of your items / rooms',
      photosHint:
        'Images and videos welcome. Up to 15 files, 50 MB total. Helps us quote more accurately.',
      photosButton: 'Choose files',
      photosSelected: 'file(s) selected',
      maxFilesNote: 'files max',
      maxTotalNote: '50 MB total',
      largeFilesNote:
        'Your files are large. We will send your details to our team and ask you to also share the photos/videos via WhatsApp or text to (813) 476-8935 — that way nothing gets lost.',
      submit: 'SEND MY DETAILS',
      submitting: 'SENDING...',
      cancel: 'Cancel',
      success: {
        title: 'GOT IT — DETAILS RECEIVED',
        message: 'Thank you. Our specialist will call you shortly from',
        phone: '(813) 476-8935',
        message2:
          'with your custom quote and final price. Please answer — the call will come from this exact number.',
        nextStepsTitle: 'What happens next',
        nextSteps: [
          'Our specialist reviews your inventory and addresses (within minutes during business hours).',
          'You receive a call from (813) 476-8935 with your custom quote and final price.',
          'Once you confirm, we lock in your moving date and your Fighters squad.',
        ],
        largeFilesTitle: 'One quick favor',
        largeFilesMessage:
          'Your photos/videos were too large to attach. Please send them via WhatsApp or text to (813) 476-8935 so we can finalize your quote faster.',
        cta: 'CLOSE',
      },
      error:
        'Something went wrong. Please try again or call us at (813) 476-8935.',
      photosTooLarge:
        'Total file size exceeds 50 MB. Please remove some or use smaller files.',
    },
    services: {
      title: 'OUR RESCUE PROTOCOLS',
      items: [
        {
          title: 'Residential Rescues',
          desc: 'Houses and apartments handled by uniformed Fighters. Stairs, tight halls, and elevators included at no extra charge.',
        },
        {
          title: 'Commercial Extractions',
          desc: 'Office and retail moves executed fast so your business never slows down.',
        },
        {
          title: 'Packing & Protection',
          desc: 'Optional packing service available. Industrial blankets, plastic wrap, and professional boxes available on request, billed separately.',
        },
        {
          title: 'Last Minute Dispatch',
          desc: 'Coordinated logistics in record time for urgent or fixed-date moves across Florida.',
        },
      ],
    },
    guarantee: {
      title: 'THE MOVE FIGHTERS GUARANTEE',
      sub: 'Transparent pricing. Honest service. Always on time.',
      items: ['No Surprise Fees', 'On-Time Arrival', 'Damage Protection'],
    },
    gallery: {
      title: 'FIGHTERS IN ACTION',
    },
    testimonials: {
      title: 'WHAT OUR RESCUED FAMILIES SAY',
      reviews: [
        {
          quote:
            'These guys are the real deal. Clear pricing, no surprises, and they treated my furniture like it was theirs. Best movers in Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: '2 months ago',
          color: 'bg-blue-500',
        },
        {
          quote:
            'I was stressed about my last-minute move but Move Fighters showed up on time and had everything done in 3 hours. Incredible.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: '3 weeks ago',
          color: 'bg-red-500',
        },
        {
          quote:
            'True professionals. Specialist called me back in minutes after I requested a quote. My 3-bedroom move was perfect from start to finish.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: '1 month ago',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: "FLORIDA'S LARGEST RESCUE NETWORK",
      subtitle: 'We cover the entire state, from the Panhandle to the Keys.',
      mapHint: 'Tap a city pin to see coverage details',
    },
    faq: {
      title: 'FREQUENTLY ASKED QUESTIONS',
      items: [
        {
          q: 'How does your pricing work?',
          a: 'We offer both flat-rate and hourly pricing depending on your move. After you request a quote, a specialist calls you to discuss the best option for your situation.',
        },
        {
          q: 'Are packing materials included?',
          a: 'Packing materials (boxes, tape, paper, plastic wrap) are billed separately based on what you actually use. Our team brings what is needed and you only pay for what is used.',
        },
        {
          q: 'What if I need to change the date?',
          a: 'You get 2 free date changes with at least 72 hours of notice.',
        },
        {
          q: 'Are you licensed and insured?',
          a: 'Yes. Move Fighters is fully licensed and insured in the State of Florida.',
        },
        {
          q: 'What areas do you cover?',
          a: 'All of Florida, from Pensacola to Key West. Coordinated dispatch for urban, suburban, and coastal areas.',
        },
        {
          q: 'Do you disassemble and reassemble furniture?',
          a: 'Yes. Beds, tables, shelves — our Fighters handle disassembly and reassembly at no extra cost on most packages.',
        },
      ],
    },
    finalCta: {
      title: 'READY FOR YOUR RESCUE?',
      sub: 'Join hundreds of Florida families who chose the Fighters. Request your quote in under 60 seconds.',
      primaryBtn: 'REQUEST MY QUOTE',
      secondaryBtn: 'CALL US',
    },
    footer: {
      helpBar: 'NEED IMMEDIATE HELP?',
      helpSub: 'Licensed & Insured — FL Mover Registration Active',
      tagline: "Florida's residential and commercial moving squad.",
      badges: [
        'Flexible Pricing',
        'No Surprise Fees',
        'Licensed & Insured',
        'Florida Local',
      ],
      newsletterTitle: 'GET MOVING TIPS & DEALS',
      emailPlaceholder: 'Enter your email',
      subscribe: 'SUBSCRIBE',
      noSpam: 'No spam. Unsubscribe anytime.',
      servicesTitle: 'OUR SERVICES',
      servicesLinks: [
        'Residential Moving',
        'Commercial Moving',
        'Furniture Assembly',
        'TV & Electronics Protection',
        'Packing & Unpacking',
        'Same-Week Scheduling',
      ],
      legalTitle: 'LEGAL',
      legalLinks: [
        'Terms of Service',
        'Privacy Policy',
        'Cancellation Policy',
        'Insurance & Liability',
      ],
      companyTitle: 'COMPANY',
      companyLinks: [
        'About Move Fighters',
        'Our Fleet',
        'Coverage Area',
        'Careers',
        'Contact Us',
      ],
      contactTitle: 'CONTACT',
      callNow: 'Call Now',
      hours: 'Mon–Sat: 7:00 AM – 8:00 PM',
      hoursSunday: 'Sunday: 8:00 AM – 5:00 PM',
      address: 'Florida — Statewide Service',
      paymentTitle: 'WE ACCEPT',
      rights: '© 2026 Move Fighters LLC. All rights reserved.',
      bottomLinks: [
        'Terms of Service',
        'Privacy Policy',
        'Cancellation Policy',
      ],
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      pricing: 'Precios',
      gallery: 'Galería',
      faq: 'Preguntas',
      rescueMe: 'COTIZAR',
    },
    hero: {
      headline: '¿MUDANZA CRÍTICA? LLAMA A LOS FIGHTERS.',
      sub: 'No solo movemos cajas; ejecutamos rescates residenciales. Tarifa fija o por hora. El escuadrón de mudanzas más confiable de Florida.',
      cta: 'OBTENER COTIZACIÓN',
    },
    trustBar: {
      moves: 'Rescates Exitosos',
      rating: 'Calificación Google',
      pricing: 'Precios Flexibles',
      licensed: 'Licencia y Seguro',
    },
    howItWorks: {
      title: 'CÓMO FUNCIONA',
      step1: {
        title: 'Solicita Tu Rescate',
        desc: 'Llena el formulario. Un especialista te llama para discutir detalles y precios.',
      },
      step2: {
        title: 'Desplegamos',
        desc: 'Nuestro escuadrón uniformado llega a tiempo con todo el equipo listo.',
      },
      step3: {
        title: 'Misión Cumplida',
        desc: 'Todo en su lugar. Factura transparente. Trabajo terminado.',
      },
    },
    booking: {
      title: 'SOLICITAR UN RESCATE',
      subtitle:
        'Llena el formulario y un especialista de Move Fighters te llamará para discutir los detalles de tu mudanza y tu cotización personalizada.',
      sizeLabel: 'Tamaño de la Mudanza',
      sizeOptions: [
        { value: 'studio', label: 'Estudio / 1 Habitación' },
        { value: '2bedroom', label: '2 Habitaciones' },
        { value: '3bedroom', label: '3 Habitaciones' },
        { value: '4bedroom', label: '4+ Habitaciones / Casa Grande' },
        { value: 'office', label: 'Oficina / Comercial' },
      ],
      serviceTypeLabel: 'Preferencia de Precio',
      serviceTypeOptions: [
        { value: 'flat', label: 'Tarifa Fija' },
        { value: 'hourly', label: 'Por Hora' },
        { value: 'either', label: 'Muéstrenme Ambos' },
      ],
      originLabel: 'Dirección de Origen',
      destLabel: 'Dirección de Destino',
      dateLabel: 'Fecha Preferida de Mudanza',
      dateHint: 'Recomendamos avisar con 72h',
      nameLabel: 'Nombre Completo',
      emailLabel: 'Correo Electrónico',
      phoneLabel: 'Número de Teléfono',
      notesLabel: 'Notas Adicionales (opcional)',
      notesPlaceholder:
        'Escaleras, artículos grandes, restricciones de parking, etc.',
      submit: 'ENVIAR SOLICITUD',
      submitting: 'ENVIANDO...',
      footer: 'No se requiere pago. Un especialista te contactará en breve.',
      success: {
        title: 'SOLICITUD RECIBIDA',
        message:
          'Gracias por elegir Move Fighters. En breve recibirás una llamada desde el',
        phone: '(813) 476-8935',
        message2:
          'con tu cotización y el precio final de tu mudanza. Por favor contesta — la llamada vendrá desde este mismo número para no perder tu rescate.',
        cta: 'VOLVER AL INICIO',
      },
      error:
        'Algo salió mal. Por favor intenta de nuevo o llámanos al (813) 476-8935.',
    },
    pricing: {
      title: 'NUESTROS PAQUETES DE MUDANZA',
      subtitle:
        'Elige el paquete que se ajuste a tu mudanza. El precio final se entrega después de una breve llamada con nuestro especialista.',
      popular: 'MÁS POPULAR',
      cta: 'COTIZAR',
      cards: [
        {
          title: 'Estudio / 1 Habitación',
          features: [
            '2 Fighters',
            'Camión de Mudanza',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Escaleras Sin Cargo Extra',
            'Seguro Residencial',
          ],
        },
        {
          title: 'Casa de 2 Habitaciones',
          features: [
            '3 Fighters',
            'Camión de Mudanza',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Escaleras Sin Cargo Extra',
            'Seguro Residencial',
          ],
        },
        {
          title: 'Casa de 3 Habitaciones',
          features: [
            '3 Fighters',
            'Camión Más Grande',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Programación Prioritaria',
            'Seguro Residencial',
          ],
        },
        {
          title: '4+ Habitaciones / Custom',
          features: [
            '4+ Fighters',
            'Múltiples Camiones',
            'Tarifa de Viaje Incluida',
            'Desarmado y Rearmado Incluido',
            'Coordinador Dedicado',
            'Servicio de Guante Blanco',
          ],
        },
      ],
      note: '* Materiales de embalaje (cajas, cinta, papel, plástico) se facturan por separado según su uso.',
    },
    quoteModal: {
      title: 'CUÉNTANOS SOBRE TU MUDANZA',
      subtitle:
        'Cuantos más detalles compartas, más precisa será tu cotización. Nuestro especialista te llamará con el precio final.',
      selectedPackage: 'Paquete seleccionado',
      sectionContact: 'Tus datos de contacto',
      sectionAddresses: 'Direcciones',
      sectionDate: '¿Cuándo te mudas?',
      sectionInventory: 'Inventario y detalles',
      sectionPhotos: 'Fotos (opcional pero recomendado)',
      nameLabel: 'Nombre Completo',
      phoneLabel: 'Teléfono',
      emailLabel: 'Correo Electrónico',
      originLabel: 'Dirección de Origen',
      originPlaceholder:
        '123 Calle Principal, Ciudad, FL — incluye piso / apto',
      destLabel: 'Dirección de Destino',
      destPlaceholder: '456 Calle Nueva, Ciudad, FL — incluye piso / apto',
      stairsLabel: 'Escaleras / Ascensor',
      stairsOptions: [
        { value: 'ground', label: 'Solo planta baja' },
        { value: 'stairs', label: 'Escaleras' },
        { value: 'elevator', label: 'Ascensor' },
        { value: 'both', label: 'Ambas ubicaciones tienen escaleras/ascensor' },
      ],
      dateLabel: 'Fecha Preferida',
      dateFlexLabel: 'Flexibilidad',
      dateFlexOptions: [
        { value: 'exact', label: 'Fecha exacta' },
        { value: 'flexible-3', label: 'Flexible (±3 días)' },
        { value: 'flexible-week', label: 'Flexible (dentro de una semana)' },
        { value: 'asap', label: 'Lo antes posible' },
      ],
      inventoryLabel: 'Describe tu inventario',
      inventoryPlaceholder:
        'Lista habitaciones y artículos principales (ej. cama king, sofá seccional, lavadora/secadora, TV 55", mesa para 6, espejos grandes, equipo de gimnasio...)',
      specialItemsLabel: 'Artículos especiales (marca todos los que apliquen)',
      specialItems: [
        'Piano',
        'Mesa de Billar',
        'Caja Fuerte',
        'Caja para Armas',
        'Arte / Antigüedades',
        'Acuario',
        'Caminadora / Gimnasio',
        'TV Grande (65"+)',
        'Jacuzzi',
        'Electrodomésticos',
      ],
      packingLabel: '¿Necesitas servicio de embalaje?',
      packingOptions: [
        { value: 'no', label: 'No, yo empaco todo' },
        { value: 'partial', label: 'Parcial — necesito ayuda con frágiles' },
        { value: 'full', label: 'Servicio completo de embalaje' },
      ],
      notesLabel: 'Necesidades especiales u otra cosa que debamos saber',
      notesPlaceholder:
        'Distancia larga de carga, puertas estrechas, restricciones de parking, ventanas de tiempo, mascotas, etc.',
      photosLabel: 'Sube fotos y videos de tus artículos / habitaciones',
      photosHint:
        'Imágenes y videos bienvenidos. Hasta 15 archivos, 50 MB en total. Nos ayuda a cotizar con precisión.',
      photosButton: 'Elegir archivos',
      photosSelected: 'archivo(s) seleccionado(s)',
      maxFilesNote: 'archivos máx',
      maxTotalNote: '50 MB total',
      largeFilesNote:
        'Tus archivos son grandes. Enviaremos tus datos a nuestro equipo y te pediremos que también compartas las fotos/videos por WhatsApp o mensaje al (813) 476-8935 — así nada se pierde.',
      submit: 'ENVIAR MIS DATOS',
      submitting: 'ENVIANDO...',
      cancel: 'Cancelar',
      success: {
        title: 'RECIBIDO — DATOS REGISTRADOS',
        message: 'Gracias. Nuestro especialista te llamará en breve desde el',
        phone: '(813) 476-8935',
        message2:
          'con tu cotización y el precio final. Por favor contesta — la llamada vendrá desde este mismo número.',
        nextStepsTitle: 'Qué sigue ahora',
        nextSteps: [
          'Nuestro especialista revisa tu inventario y direcciones (en minutos durante horario laboral).',
          'Recibes una llamada desde el (813) 476-8935 con tu cotización personalizada y el precio final.',
          'Una vez confirmes, aseguramos tu fecha y tu escuadrón de Fighters.',
        ],
        largeFilesTitle: 'Un pequeño favor',
        largeFilesMessage:
          'Tus fotos/videos eran demasiado grandes para adjuntar. Envíalas por WhatsApp o mensaje al (813) 476-8935 para finalizar tu cotización más rápido.',
        cta: 'CERRAR',
      },
      error:
        'Algo salió mal. Por favor intenta de nuevo o llámanos al (813) 476-8935.',
      photosTooLarge:
        'El tamaño total de los archivos supera los 50 MB. Elimina algunos o usa archivos más pequeños.',
    },
    services: {
      title: 'NUESTROS PROTOCOLOS DE RESCATE',
      items: [
        {
          title: 'Rescate Residencial',
          desc: 'Casas y apartamentos manejados por Fighters uniformados. Escaleras, pasillos estrechos y elevadores incluidos sin cargo extra.',
        },
        {
          title: 'Mudanzas Comerciales',
          desc: 'Mudanzas de oficinas y locales ejecutadas rápido para que tu negocio nunca se detenga.',
        },
        {
          title: 'Embalaje y Protección',
          desc: 'Servicio de embalaje opcional disponible. Mantas industriales, plástico protector y cajas profesionales disponibles bajo solicitud, facturados por separado.',
        },
        {
          title: 'Despacho de Prioridad',
          desc: 'Logística coordinada en tiempo récord para mudanzas urgentes o con fecha fija en toda Florida.',
        },
      ],
    },
    guarantee: {
      title: 'LA GARANTÍA MOVE FIGHTERS',
      sub: 'Precios transparentes. Servicio honesto. Siempre puntuales.',
      items: [
        'Sin Cargos Sorpresa',
        'Llegada Puntual',
        'Protección contra Daños',
      ],
    },
    gallery: {
      title: 'FIGHTERS EN ACCIÓN',
    },
    testimonials: {
      title: 'LO QUE DICEN NUESTRAS FAMILIAS RESCATADAS',
      reviews: [
        {
          quote:
            'Estos chicos son de verdad. Precios claros, sin sorpresas, y trataron mis muebles como si fueran suyos. ¡Los mejores de Tampa!',
          name: 'Maria G.',
          location: 'Tampa, FL',
          timeAgo: 'hace 2 meses',
          color: 'bg-blue-500',
        },
        {
          quote:
            'Estaba estresado por mi mudanza de último minuto, pero Move Fighters llegó a tiempo y terminó todo en 3 horas. Increíble.',
          name: 'James R.',
          location: 'Orlando, FL',
          timeAgo: 'hace 3 semanas',
          color: 'bg-red-500',
        },
        {
          quote:
            'Profesionales de verdad. El especialista me llamó en minutos después de pedir cotización. Mi mudanza de 3 habitaciones fue perfecta.',
          name: 'Carlos M.',
          location: 'Miami, FL',
          timeAgo: 'hace 1 mes',
          color: 'bg-green-500',
        },
      ],
    },
    coverage: {
      title: 'LA RED DE RESCATE MÁS GRANDE DE FLORIDA',
      subtitle: 'Cubrimos todo el estado, desde el Panhandle hasta los Keys.',
      mapHint: 'Toca un pin para ver detalles de cobertura',
    },
    faq: {
      title: 'PREGUNTAS FRECUENTES',
      items: [
        {
          q: '¿Cómo funcionan los precios?',
          a: 'Ofrecemos tarifa fija y por hora dependiendo de tu mudanza. Después de solicitar cotización, un especialista te llama para discutir la mejor opción para tu situación.',
        },
        {
          q: '¿Los materiales de embalaje están incluidos?',
          a: 'Los materiales (cajas, cinta, papel, plástico) se facturan por separado según lo que realmente uses. Nuestro equipo trae lo necesario y solo pagas lo que se utiliza.',
        },
        {
          q: '¿Qué pasa si necesito cambiar la fecha?',
          a: 'Tienes 2 cambios de fecha gratis con al menos 72 horas de aviso.',
        },
        {
          q: '¿Tienen licencia y seguro?',
          a: 'Sí. Move Fighters cuenta con licencia completa y seguro en el Estado de Florida.',
        },
        {
          q: '¿Qué áreas cubren?',
          a: 'Toda Florida, desde Pensacola hasta Key West. Despacho coordinado para áreas urbanas, suburbanas y costeras.',
        },
        {
          q: '¿Desarman y rearman muebles?',
          a: 'Sí. Camas, mesas, estantes — nuestros Fighters se encargan del desarmado y rearmado sin costo extra en la mayoría de los paquetes.',
        },
      ],
    },
    finalCta: {
      title: '¿LISTO PARA TU RESCATE?',
      sub: 'Únete a cientos de familias de Florida que eligieron a los Fighters. Solicita tu cotización en menos de 60 segundos.',
      primaryBtn: 'COTIZAR AHORA',
      secondaryBtn: 'LLÁMANOS',
    },
    footer: {
      helpBar: '¿NECESITAS AYUDA INMEDIATA?',
      helpSub: 'Con Licencia y Seguro — Registro de Mudanzas FL Activo',
      tagline: 'El escuadrón residencial y comercial de mudanzas de Florida.',
      badges: [
        'Precios Flexibles',
        'Sin Cargos Sorpresa',
        'Licencia y Seguro',
        'Local de Florida',
      ],
      newsletterTitle: 'CONSEJOS Y OFERTAS',
      emailPlaceholder: 'Tu correo electrónico',
      subscribe: 'SUSCRIBIRSE',
      noSpam: 'Sin spam. Cancela cuando quieras.',
      servicesTitle: 'NUESTROS SERVICIOS',
      servicesLinks: [
        'Mudanza Residencial',
        'Mudanza Comercial',
        'Armado de Muebles',
        'Protección de TV y Electrónicos',
        'Embalaje y Desembalaje',
        'Programación Misma Semana',
      ],
      legalTitle: 'LEGAL',
      legalLinks: [
        'Términos de Servicio',
        'Política de Privacidad',
        'Política de Cancelación',
        'Seguro y Responsabilidad',
      ],
      companyTitle: 'EMPRESA',
      companyLinks: [
        'Sobre Move Fighters',
        'Nuestra Flota',
        'Área de Cobertura',
        'Carreras',
        'Contáctanos',
      ],
      contactTitle: 'CONTACTO',
      callNow: 'Llamar Ahora',
      hours: 'Lun–Sáb: 7:00 AM – 8:00 PM',
      hoursSunday: 'Domingo: 8:00 AM – 5:00 PM',
      address: 'Florida — Servicio Estatal',
      paymentTitle: 'ACEPTAMOS',
      rights: '© 2026 Move Fighters LLC. Todos los derechos reservados.',
      bottomLinks: [
        'Términos de Servicio',
        'Política de Privacidad',
        'Política de Cancelación',
      ],
    },
  },
}
